import { Divider, Radio, Typography } from "antd";
import { Empty, Flex } from "antd/lib";
import apiHelper from "api/apiHelper";
import { LoadingSpinner } from "components/LoadingSpinner";
import { useEffect, useState } from "react";
import { COLOR_PRIMARY_BG } from "theme/colors";

export const DocumentationV2: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [docs, setDocs] = useState<any>([] as any);
  const [selectedDocIndex, setSelectedDocIndex] = useState<number | undefined>(0);
  const getAllDocuments = async () => {
    const url = "/document";
    const response: any = await apiHelper.get(url, {});
    if (response.data.statusCode === 200) {
      return { success: true, data: response.data.data };
    }
    return { error: true, data: [] };
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await getAllDocuments();
      setDocs(res.data);
      setLoading(false);
      setSelectedDocIndex(0);
    })();
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <div>
        <Typography.Title style={{ fontWeight: "normal", fontSize: "30px" }} level={1}>
          Documentation
        </Typography.Title>
        <Typography.Text>Get a proper understanding of how QuiX works</Typography.Text>

        <Radio.Group
          style={{ marginBottom: 4, marginTop: 16, display: "flex", flexWrap: "wrap" }}
          value={selectedDocIndex}>
          {docs.map((doc: any, index: number) => {
            return (
              <Radio.Button
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedDocIndex(index);
                  }
                }}
                checked={selectedDocIndex === index}
                style={{
                  color: "#CECFD2",
                  width: "fit-content",
                  display: "grid",
                  alignItems: "center"
                }}
                value={index}>
                <Typography.Paragraph
                  ellipsis
                  title={doc.title}
                  style={{
                    maxWidth: "140px",
                    padding: 0,
                    marginBottom: 0
                  }}>
                  {doc.title}
                </Typography.Paragraph>
              </Radio.Button>
            );
          })}
        </Radio.Group>

        <Divider style={{ backgroundColor: "#404040" }} />

        {(!docs || docs.length === 0) && (
          <Empty
            description={
              <Typography.Text style={{ color: "#CECFD2" }}>No documents found</Typography.Text>
            }
          />
        )}

        {selectedDocIndex !== undefined && (
          <Flex
            vertical
            style={{
              background: COLOR_PRIMARY_BG,
              borderRadius: "8px",
              padding: "12px 12px 0 0"
            }}>
            <Typography.Title
              style={{ fontFamily: "Titillium web", fontSize: "24px", marginBottom: "12px" }}>
              {docs[selectedDocIndex]?.title}
            </Typography.Title>

            <div
              style={{ overflow: "auto", lineHeight: "1.57" }}
              dangerouslySetInnerHTML={{
                __html: docs[selectedDocIndex]?.content.replace(
                  /<p>\s*<br\s*\/?>\s*<\/p>/g,
                  "<p style='height: 2px' />"
                )
              }}></div>
          </Flex>
        )}
      </div>
    </>
  );
};
